import { accountService } from './accountService';

export default accountService;
